<template>
  <div class="flex min-h-screen flex-col bg-slate-50 font-sans text-slate-700">
    <HeaderComp />
    <main class="flex flex-1 flex-col">
      <!-- Keyed by route name so /rehvid and /veljed, which share a
           component, each mount fresh when switching tabs. -->
      <router-view :key="$route.name" />
    </main>
    <FooterComp />
  </div>
</template>

<script>
import HeaderComp from "@/components/HeaderComp.vue";
import FooterComp from "@/components/FooterComp.vue";

export default {
  name: "App",
  components: {
    HeaderComp,
    FooterComp,
  },
};
</script>
